module.exports = __webpack_public_path__ + "media/images/symbols/facebook-d4f2bcf62213c01340ce2d22b22e249b.svg";